import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client";

/**
 * Посещаемость Юнифанса за период (21.09, владелец) — GET /api/commerce/visits.
 * Сервер отдаёт СРАЗУ все разрезы периода, поэтому переключение метрики и разреза
 * в подвкладке мгновенное: повторный запрос нужен только при смене дат или тумблера
 * «сотрудники».
 */
export interface VisitBucket {
  d: string; events: number; visitors: number; newVisitors: number; opens: number; taps: number; views: number;
  channels: Record<string, number>; screens: Record<string, number>;
}
export interface VisitsData {
  from: string; to: string; days: number; staff: boolean;
  /** сегодняшний бизнес-день — последний столбец ещё идёт, это не «падение» */
  today: string;
  /** часть запросов не отработала — цифры неполные, интерфейс об этом говорит */
  partial: boolean;
  buckets: VisitBucket[];
  hours: { k: number; events: number; visitors: number; opens: number }[];
  dow: { k: number; events: number; visitors: number }[];
  /* сетка «день недели × час» — ненулевые клетки (не больше 168) */
  grid: { d: number; h: number; visitors: number; events: number }[];
  screens: { k: string; people: number; n: number }[];
  channels: { k: string; people: number; n: number }[];
  /** людей, открывавших приложение, и сколько из них без метки (пересечения учтены) */
  channelsTotal: { people: number; noMark: number };
  frequency: { days: number; people: number }[];
  retention: { yesterday: number; returned: number; day: string };
  funnel: { visitors: number; paper: number; quest: number; book: number; shop: number; fan: number; tip: number };
  totals: { visitors: number; newVisitors: number; returning: number; opens: number; events: number; eventsPerVisitor: number };
  prev: { visitors: number; opens: number; events: number; from: string; to: string };
}

export function useUnifansVisits(from: string, to: string, staff: boolean): {
  data: VisitsData | null; loading: boolean; error: string | null; reload: () => void;
} {
  const [data, setData] = useState<VisitsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [trigger, setTrigger] = useState(0);
  const reload = useCallback(() => setTrigger((n) => n + 1), []);

  useEffect(() => {
    if (!from || !to) return;
    let alive = true;
    setLoading(true); setError(null);
    api<VisitsData>(`/api/commerce/visits?from=${from}&to=${to}${staff ? "&staff=1" : ""}`)
      .then((r) => { if (alive) { setData(r); setLoading(false); } })
      .catch((e: unknown) => { if (alive) { setError(e instanceof Error ? e.message : "Не удалось загрузить статистику"); setLoading(false); } });
    return () => { alive = false; };
  }, [from, to, staff, trigger]);

  return { data, loading, error, reload };
}
